

(() => {
  "use strict";


  const ED = !!(window.Shopify && Shopify.designMode);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));


  function qs(root, sel) {
    try { return (root || document).querySelector(sel); } catch { return null; }
  }
  function qsa(root, sel) {
    try { return Array.from((root || document).querySelectorAll(sel)); } catch { return []; }
  }


  function sectionIdFromScriptTag() {
    try {
      const scripts = qsa(document, 'script[src*="product-information.js"][data-section-id]');
      const sc = scripts[scripts.length - 1];
      const sid = sc ? String(sc.getAttribute("data-section-id") || "").trim() : "";
      return sid || "";
    } catch {
      return "";
    }
  }


  function findRoot() {
    try {
      const sid = sectionIdFromScriptTag();
      if (sid) {
        const marker = qs(document, `[data-pinfo-marker="${CSS.escape(sid)}"]`);
        if (marker) {
          return (
            marker.closest(`#shopify-section-${CSS.escape(sid)}`) ||
            marker.closest('[id^="shopify-section-"]') ||
            null
          );
        }
        const direct = qs(document, `#shopify-section-${CSS.escape(sid)}`);
        if (direct) return direct;
      }


      const markerAny = qs(document, "[data-pinfo-marker]");
      if (!markerAny) return null;
      return markerAny.closest('[id^="shopify-section-"]') || null;
    } catch {
      return null;
    }
  }


  function killSticky(root) {
    try { qsa(root || document, "sticky-add-to-cart").forEach((el) => el.remove()); } catch {}
  }


  async function waitForDetails(root) {
    for (let i = 0; i < 100; i++) { // ~10s
      const details = qs(root, '[data-testid="product-information-details"]');
      if (details) return details;
      await sleep(100);
    }
    return null;
  }


  function clearPendingFlags({ descReady, priceReady }) {
    try {
      const html = document.documentElement;
      if (descReady) html.classList.remove("pinfo-desc-pending");
      if (priceReady) html.classList.remove("pinfo-price-pending");
    } catch {}
  }


  function detectDesc(details) {
    try { return qs(details, "rte-formatter"); } catch { return null; }
  }


  function detectPriceContainer(details) {
    try { return qs(details, '[ref="priceContainer"]'); } catch { return null; }
  }


  function releasePendingIfPossible(root) {
    try {
      const details = qs(root, '[data-testid="product-information-details"]');
      if (!details) return;


      const descReady = !!detectDesc(details);
      const priceReady = !!detectPriceContainer(details);


      clearPendingFlags({ descReady, priceReady });
    } catch {}
  }




  function findPriceAnchor(details) {


    const pp =
      qs(details, "product-price[data-product-id]") ||
      qs(details, "product-price") ||
      null;


    if (pp) return pp;


    const pc = qs(details, '[ref="priceContainer"]');
    return pc || null;
  }


  function ensureDescAbovePrice(root) {
    try {
      if (!root) return false;


      const details = qs(root, '[data-testid="product-information-details"]');
      if (!details) return false;


      const desc = detectDesc(details);
      if (!desc) return false;


      desc.setAttribute("data-pinfo-desc-white", "1");


      const anchor = findPriceAnchor(details);
      if (!anchor) return false;


      if (anchor.compareDocumentPosition(desc) & Node.DOCUMENT_POSITION_PRECEDING) return true;


      anchor.parentNode.insertBefore(desc, anchor);
      return true;
    } catch {
      return false;
    }
  }


  function injectCSS() {
    if (document.getElementById("PINFO_COMPARE_CSS")) return;
    const st = document.createElement("style");
    st.id = "PINFO_COMPARE_CSS";
    st.textContent = `
      .compare-at-price,
      [data-pinfo-compare="1"]{
        display:inline-block !important;
        visibility:visible !important;
        opacity:.35 !important;
        max-height:none !important;
        overflow:visible !important;
        white-space:nowrap !important;
      }
    `;
    document.head.appendChild(st);
  }


  function getHandle() {
    try {
      const p = location.pathname || "";
      const m = p.match(/\/products\/([^\/\?#]+)/i);
      if (m && m[1]) return decodeURIComponent(m[1]);
    } catch {}
    return "";
  }


  function getVariantId(root) {
    try {
      const u = new URL(location.href);
      const v = u.searchParams.get("variant");
      if (v && /^\d+$/.test(v)) return Number(v);
    } catch {}


    try {
      const details = qs(root, '[data-testid="product-information-details"]') || root || document;
      const inp =
        qs(details, 'form input[name="id"][value]') ||
        qs(details, 'input[name="id"][value]');
      const val = inp ? String(inp.value || "").trim() : "";
      if (val && /^\d+$/.test(val)) return Number(val);
    } catch {}


    return 0;
  }


  function detectCurrencyFromText(txt) {
    const t = String(txt || "");
    if (t.includes("R$")) return { code: "BRL", sym: "R$" };
    if (t.includes("€"))  return { code: "EUR", sym: "€" };
    if (t.includes("£"))  return { code: "GBP", sym: "£" };
    if (t.includes("$"))  return { code: "", sym: "$" };
    return { code: "", sym: "" };
  }


  function formatMoneyCents(cents, hintText) {
    const n = Number(cents || 0) / 100;


    let code = "";
    try {
      code =
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.iso_code ||
        "";
    } catch {}


    const hint = detectCurrencyFromText(hintText);
    if (!code) code = hint.code || "EUR";


    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: code,
        maximumFractionDigits: 2
      }).format(n);
    } catch {
      const sym = hint.sym || "";
      const fixed = n.toFixed(2).replace(".", ",");
      return sym ? `${sym}${fixed}` : fixed;
    }
  }


  const PRODUCT_CACHE = new Map();


  async function fetchProductJSON(handle) {
    try {
      if (!handle) return null;
      if (PRODUCT_CACHE.has(handle)) return PRODUCT_CACHE.get(handle);


      const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!r.ok) return null;


      const j = await r.json();
      PRODUCT_CACHE.set(handle, j);
      return j;
    } catch {
      return null;
    }
  }


  function ensureCompareSpanIn(container) {
    if (!container) return null;


    const nativeCompare =
      qs(container, ".compare-at-price") ||
      qs(container, ".price__compare-at") ||
      qs(container, "s");
    if (nativeCompare && !nativeCompare.hasAttribute("data-pinfo-compare")) return nativeCompare;


    let el = qs(container, '[data-pinfo-compare="1"]');
    if (el) return el;


    el = document.createElement("span");
    el.setAttribute("data-pinfo-compare", "1");
    el.className = "compare-at-price";
    el.style.textDecoration = "line-through";
    el.style.whiteSpace = "nowrap";
    el.style.opacity = ".35";
    el.style.fontSize = "14px";
    el.style.display = "inline-block";
    el.style.marginLeft = "10px";


    const priceEl =
      qs(container, ".price-item--sale") ||
      qs(container, ".price__sale .price-item") ||
      qs(container, "span.price") ||
      container.firstElementChild;


    if (priceEl && priceEl.parentNode === container) priceEl.insertAdjacentElement("afterend", el);
    else container.appendChild(el);


    return el;
  }


  function removeCompareSpan(container) {
    try { qs(container, '[data-pinfo-compare="1"]')?.remove(); } catch {}
  }


  async function updateCompareAt(root) {
    try {
      if (!root) return;


      const details = qs(root, '[data-testid="product-information-details"]');
      if (!details) return;


      const container = qs(details, '[ref="priceContainer"]');
      if (!container) return;


      const handle = getHandle();
      if (!handle) return;


      const variantId = getVariantId(root);
      if (!variantId) { removeCompareSpan(container); return; }


      const product = await fetchProductJSON(handle);
      if (!product || !Array.isArray(product.variants)) { removeCompareSpan(container); return; }


      const v = product.variants.find((x) => Number(x.id) === Number(variantId));
      if (!v) { removeCompareSpan(container); return; }


      const price = Number(v.price || 0);
      const compare = Number(v.compare_at_price || 0);


      if (!compare || compare <= price) {
        removeCompareSpan(container);
        return;
      }


      const hint = String(container.textContent || details.textContent || "").replace(/\s+/g, " ").trim();
      const compareEl = ensureCompareSpanIn(container);
      if (compareEl) compareEl.textContent = formatMoneyCents(compare, hint);
    } catch {}
  }


  function hookVariantEvents(root, ping) {
    try {
      root.addEventListener("theme:variant:update", ping, { passive: true });
      root.addEventListener("variant:update", ping, { passive: true });
      window.addEventListener("variant:change", ping, { passive: true });
      window.addEventListener("product:variant-change", ping, { passive: true });
    } catch {}
  }


  function observeReRenders(root) {
    try {
      const details = qs(root, '[data-testid="product-information-details"]');
      if (!details) return;


      let t = 0;
      const ping = () => {
        clearTimeout(t);
        t = setTimeout(() => {
          ensureDescAbovePrice(root);
          releasePendingIfPossible(root);
          updateCompareAt(root);
        }, 90);
      };


      const mo = new MutationObserver(ping);
      mo.observe(details, { childList: true, subtree: true, characterData: true, attributes: true });


      const idInput =
        qs(details, 'form input[name="id"]') ||
        qs(details, 'input[name="id"]');
      if (idInput) {
        const mo2 = new MutationObserver(ping);
        mo2.observe(idInput, { attributes: true, attributeFilter: ["value"] });
        idInput.addEventListener("change", ping, { passive: true });
      }


      hookVariantEvents(root, ping);
      ping();
      setTimeout(() => { try { mo.disconnect(); } catch {} }, 30000);
    } catch {}
  }


  function scheduleReinforce(root) {
    const f = () => {
      ensureDescAbovePrice(root);
      releasePendingIfPossible(root);
      updateCompareAt(root);
    };
    f();
    setTimeout(f, 120);
    setTimeout(f, 420);
    setTimeout(f, 900);
    setTimeout(f, 1700);
    setTimeout(f, 3200);
  }


  async function boot() {
    injectCSS();


    const root = findRoot();
    if (!root) return;


    if (!ED) killSticky(root);


    const details = await waitForDetails(root);
    if (!details) return;


    scheduleReinforce(root);
    observeReRenders(root);
  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
